export default store => store.rewards;
